<template>
  <v-text-field :readonly="readonly" v-model.number="model[`${prop.value}`]" :label="prop.text" type="number"
    :clearable="!readonly" :color="prop.color">

  </v-text-field>
</template>

<style scoped>

</style>

<script>
  import NumberInput from "./numberInput.ts";
  export default NumberInput;
</script>